import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";


const breadcrumbsStatic = [{
	name: 'Forms',
	url: '/forms',
	icon: 'dashboard',
}];

export default class Refund_Agreement extends Framework.Components.View {

	render() {
		let {match, baseUrl} = this.props
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Refund Agreement",
				url: `/forms/refund_agreement`,
				icon: 'book',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Objects.RefundAgreement
					id={match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
				/>
			</div>
		);
	}
}

